/*
 * Author: Roger
 * File Created: Thursday, 24-08-08 04:15 pm
 * Last Modified: Monday, 25-03-17 03:20 pm, by Harper Yan
 */

import { useRef } from 'react';

import { useTranslation } from 'next-i18next';

import { motion, useInView, useScroll, useTransform } from 'framer-motion';

import { type BoxProps, useMediaQuery } from '@mui/material';
import { Flex } from '@ucard/ds/containers';
import theme from '@ucard/ds/theme';

interface ScaleTextProps extends BoxProps {
  scaleSize?: number;
}

const ScaleText: React.FC<ScaleTextProps> = ({
  scaleSize = 1.285,
  children,
  ...props
}) => {
  const { t } = useTranslation('home');
  const ref = useRef(null);
  const isInView = useInView(ref);

  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'center center'],
  });
  const scale = useTransform(scrollYProgress, [0, 1], [scaleSize, 1]);

  const md = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Flex justifyContent="center" pb={[0, 0, 10, 0]} {...props}>
      <motion.div
        animate={{ opacity: isInView ? 1 : 0 }}
        initial={{ opacity: 0, scale: scaleSize }}
        ref={ref}
        style={{
          scale: isInView ? scale : scaleSize,
          textAlign: 'center',
          ...(md && { display: 'flex', gap: '10px', alignItems: 'center' }),
        }}
        transition={{ duration: 0.5 }}>
        {children}
      </motion.div>
    </Flex>
  );
};

export default ScaleText;
